export class ReportTemplateData {
  constructor(init?: Partial<ReportTemplateData>) {
    if (init) {
      Object.assign(this, init);
    }
  }

  Id?: number;
  Number?: number;
  Name1?: string;
  Name2?: string;
  Info?: string;
  FileName?: string;
  AspectCoefficient?: number;
  CompanyId?: number;
  QueryCase?: number;
  ReportViewPermission?: number;
  DataSourceQualifiedName: string;
}

export enum ReportViewPoint {
  None = 0,
  Customer = 2, // CT (AG)
  Contractor = 4, // CO (AN)
  Subcontractor = 1, // SC
  All = 7
}
